<template>
  <div class="fixed inset-0 z-[10000] flex items-center justify-center bg-black/50 backdrop-blur-[4px]" @click.self="$emit('close')">
    <div class="bg-n-background rounded-2xl shadow-2xl w-full max-w-3xl max-h-[85vh] flex flex-col">
      <div class="px-6 py-5 border-b border-n-weak flex items-center justify-between">
        <h2 class="text-lg font-extrabold text-n-slate-12">Templates de tarefa</h2>
        <button class="text-n-slate-9 hover:text-n-slate-11 text-xl" @click="$emit('close')">×</button>
      </div>
      <div class="px-6 py-4 space-y-3 overflow-y-auto flex-1">
        <div class="space-y-2 border border-n-weak rounded-xl p-3">
          <div class="flex items-center gap-2">
            <input v-model="newTmpl.name" placeholder="Nome do template" class="flex-1 px-3 py-2 rounded border border-n-strong bg-n-background dark:bg-n-solid-2 text-sm" />
            <button class="px-3 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded text-sm font-medium disabled:opacity-50" :disabled="creating || !newTmpl.name.trim()" @click="createTmpl">{{ creating ? '...' : '+ Criar' }}</button>
          </div>
          <input v-model="newTmpl.description" placeholder="Descricao (opcional)" class="w-full px-3 py-2 rounded border border-n-strong bg-n-background dark:bg-n-solid-2 text-xs" />
          <div class="text-xs text-n-slate-10">Subtarefas (uma por linha)</div>
          <textarea v-model="newTmpl.subtasksText" rows="3" placeholder="Item 1&#10;Item 2&#10;Item 3" class="w-full px-3 py-2 rounded border border-n-strong bg-n-background dark:bg-n-solid-2 text-xs font-mono"></textarea>
        </div>
        <div v-if="templates.length === 0" class="text-center py-6 text-sm text-n-slate-9">Nenhum template criado ainda</div>
        <ul v-else class="space-y-1">
          <li v-for="t in templates" :key="t.id" class="flex items-center gap-2 p-2 rounded hover:bg-n-alpha-1">
            <div class="flex-1">
              <div class="text-sm font-medium text-n-slate-12">{{ t.name }}</div>
              <div class="text-xs text-slate-450">{{ (t.default_subtasks || []).length }} subtarefas - usado {{ t.usage_count || 0 }}x</div>
            </div>
            <button class="px-3 py-1 bg-green-600 hover:bg-green-700 text-white rounded text-xs" @click="applyTmpl(t)">Usar</button>
            <button class="text-n-slate-9 hover:text-red-500 px-1 text-lg" @click="removeTmpl(t)">×</button>
          </li>
        </ul>
      </div>
      <div class="px-6 py-3 border-t border-n-weak flex justify-end">
        <button class="px-4 py-1.5 text-sm rounded-xl bg-n-alpha-2 hover:bg-slate-200 text-n-slate-11" @click="$emit('close')">Fechar</button>
      </div>
    </div>
  </div>
</template>


<script>
import { useAlert } from 'dashboard/composables';
import TaskTemplatesAPI from 'dashboard/api/taskTemplates';

export default {
  name: 'TaskTemplatesManager',
  emits: ['close', 'applied'],
  data() { return { templates: [], newTmpl: { name: '', description: '', subtasksText: '' }, creating: false }; },
  mounted() { this.load(); },
  methods: {
    async load() {
      try {
        const { data } = await TaskTemplatesAPI.list();
        this.templates = Array.isArray(data) ? data : [];
      } catch (e) { useAlert('Erro ao carregar templates'); }
    },
    async createTmpl() {
      if (!this.newTmpl.name.trim()) return;
      this.creating = true;
      try {
        const subtasks = (this.newTmpl.subtasksText || '').split('\n').map((s, i) => ({ title: s.trim(), position: i })).filter(x => x.title);
        const { data } = await TaskTemplatesAPI.create({ name: this.newTmpl.name.trim(), description: this.newTmpl.description || null, default_subtasks: subtasks, default_priority: 2 });
        this.templates.unshift(data);
        this.newTmpl = { name: '', description: '', subtasksText: '' };
        useAlert('Template criado');
      } catch (e) { useAlert('Erro ao criar'); }
      finally { this.creating = false; }
    },
    async applyTmpl(t) {
      try {
        const { data } = await TaskTemplatesAPI.apply(t.id, {});
        this.$emit('applied', data);
        useAlert('Tarefa criada');
        t.usage_count = (t.usage_count || 0) + 1;
      } catch (e) { useAlert('Erro ao aplicar'); }
    },
    async removeTmpl(t) {
      if (!window.confirm('Remover template?')) return;
      try {
        await TaskTemplatesAPI.remove(t.id);
        this.templates = this.templates.filter(x => x.id !== t.id);
        useAlert('Removido');
      } catch (e) { useAlert('Erro ao remover'); }
    },
  },
};
</script>

